import React from "react";

/**
 * Hook to detect clicks outside of a component.
 * https://www.robinwieruch.de/react-hook-detect-click-outside-component/
 */
export default function useOutsideClick(callback: () => void) {
  const ref = React.useRef<any>(null);

  React.useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [ref, callback]);

  return ref;
}
